import { useEffect } from 'react'

/**
 * Registra o service worker estático em /sw.js.
 * Necessário para Web Push + PWA installable.
 * Idempotente: roda uma vez por load, ignora se o browser não suporta.
 */
const ServiceWorkerRegister = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!('serviceWorker' in navigator)) return

    const register = async () => {
      try {
        await navigator.serviceWorker.register('/sw.js', { scope: '/' })
      } catch (error) {
        // Silencioso: falha de registro não deve afetar a app
        console.error('[sw] registration failed:', error)
      }
    }

    register()
  }, [])

  return null
}

export default ServiceWorkerRegister
